<template>
  <admin-layout>
    <template v-slot:breadcrumb>
      <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        <li class="breadcrumb-item text-sm">
          <a class="opacity-5 text-white" href="javascript:;">Admin</a>
        </li>
        <li class="breadcrumb-item text-sm text-white" aria-current="page">
          Noticias
        </li>
      </ol>
    </template>

    <template v-slot:header>
      <h5 class="font-weight-bolder text-white mt-4 mb-0">Noticias</h5>
    </template>

    <template #content>
      <div class="row">
        <div class="col-12">
          <div class="card mb-4">
            <div class="card-header pb-0">
              <div class="row">
                <div class="col-8">
                  <button class="btn btn-primary" @click="openModal()">
                    Novo <i class="fas fa-plus"></i>
                  </button>
                </div>

                <div class="col-4">
                  <div class="input-group">
                    <input
                      v-model="filter"
                      @keyup="search"
                      type="text"
                      class="form-control"
                      placeholder="Pesquisar"
                    />
                    <span class="input-group-text text-body"
                      ><i
                        @click="search"
                        class="fas fa-search"
                        style="cursor: pointer"
                        aria-hidden="true"
                      ></i
                    ></span>
                  </div>
                </div>
              </div>
              <div class="row mx-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="filterAtivo"
                    id="fcustomCheck1"
                    @change="filterNoticiasAtivos"
                  />
                  <label class="custom-control-label" for="customCheck1"
                    >Somente ativos</label
                  >
                </div>
              </div>
            </div>

            <div class="card-body px-0 pt-0 pb-2">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>

                      <th
                        class="
                          text-uppercase text-secondary text-xxs
                          font-weight-bolder
                          opacity-7
                        "
                      >
                        Titulo
                      </th>

                 <!--      <th
                        v-if="$page.props.auth.hasRole.superAdmin"
                        class="
                          text-uppercase text-secondary text-xxs
                          font-weight-bolder
                          opacity-7
                        "
                      >
                        Prefeitura
                      </th> -->

                      <th
                        class="
                          text-uppercase text-secondary text-xxs
                          font-weight-bolder
                          opacity-7
                        "
                      >
                        Categoria
                      </th>

                      <th
                        class="
                          text-uppercase text-secondary text-xxs
                          font-weight-bolder
                          opacity-7
                        "
                      >
                        Ativo
                      </th>

                      <th
                        class="
                          text-center text-uppercase text-secondary text-xxs
                          font-weight-bolder
                          opacity-7
                        "
                      >
                        Data de criação
                      </th>
                      <th class="text-secondary opacity-7"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(noticia, index) in noticias.data" :key="index">
                <!--       <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <h6 class="mb-0 text-sm">{{ noticia.id }}</h6>

                          </div>
                        </div>
                      </td>
 -->
                      <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <h6 class="mb-0 text-sm">
                              {{ noticia.titulo }}
                            </h6>
                            <!--        <p class="text-xs text-secondary mb-0">
                              john@creative-tim.com
                            </p> -->
                          </div>
                        </div>
                      </td>

                   <!--    <td v-if="$page.props.auth.hasRole.superAdmin">
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <h6 class="mb-0 text-sm">
                              {{ noticia.prefeitura.descricao }}
                            </h6>
                          </div>
                        </div>
                      </td> -->

                      <td>
                        <div class="px-4 py-1">
                          <div class="justify-content-center">
                            <h6 class="mb-0 text-sm">
                              {{ noticia.categoria.descricao }}
                            </h6>
                            <!--        <p class="text-xs text-secondary mb-0">
                              john@creative-tim.com
                            </p> -->
                          </div>
                        </div>
                      </td>

                      <td v-if="noticia.ativo" class="text-sm">
                        <span class="mx-2 badge badge-sm bg-gradient-success"
                          >Ativo</span
                        >
                      </td>

                      <td v-if="!noticia.ativo" class="mx-3 text-sm">
                        <span class="mx-2 badge badge-sm bg-gradient-danger"
                          >Inativo</span
                        >
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">{{
                          formatarData(noticia.created_at)
                        }}</span>
                      </td>
                      <td class="align-middle">
                        <a
                          href="javascript:;"
                          class="text-secondary font-weight-bold text-xs"
                          data-toggle="tooltip"
                          data-original-title="Edit"
                          @click.prevent="edit(noticia)"
                        >
                          Editar </a
                        >|
                        <a
                          href="javascript:;"
                          class="text-secondary font-weight-bold text-xs"
                          @click="deleteModal(noticia)"
                        >
                          Remover
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <pagination :links="noticias.links"></pagination>
            </div>
          </div>
        </div>
      </div>
    </template>
  </admin-layout>

  <!-- Modal -->
  <div
    class="modal fade"
    id="modalNoticia"
    tabindex="-1"
    aria-labelledby="modalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form @submit.prevent="checkMode">
          <div class="modal-header">
            <h5 class="modal-title" id="modalLabel">{{ formTitle }}</h5>
            <span
              style="cursor: pointer"
              @click="closeModal"
              aria-label="Close"
              aria-hidden="true"
              >×</span
            >
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Título</label
                  >
                  <input
                    v-model="form.titulo"
                    class="form-control"
                    type="text"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    :class="{ 'is-invalid': form.errors.titulo }"
                  />
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.titulo }"
                >
                  {{ form.errors.titulo }}
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Data do Evento</label
                  >
                  <input
                    v-model="form.data_evento"
                    class="form-control"
                    type="date"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    :class="{ 'is-invalid': form.errors.data_evento }"
                  />
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.data_evento }"
                >
                  {{ form.errors.data_evento }}
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Categoria</label
                  >
                  <select
                    id="noticia_categoria_id"
                    v-model="form.noticia_categoria_id"
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.noticia_categoria_id }"
                  >
                    <option
                      v-for="(cat, index) in categorias"
                      :key="index"
                      :value="cat.id"
                    >
                      {{ cat.descricao }}
                    </option>
                  </select>
                </div>
                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.noticia_categoria_id }"
                >
                  {{ form.errors.noticia_categoria_id }}
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="example-text-input" class="form-control-label"
                    >Descrição</label
                  >
                  <textarea
                    v-model="form.descricao"
                    class="form-control"
                    onfocus="focused(this)"
                    onfocusout="defocused(this)"
                    :class="{ 'is-invalid': form.errors.descricao }"
                    rows="4"
                  >
                  </textarea>
                </div>

                <div
                  class="invalid-feedback mb-3"
                  :class="{ 'd-block': form.errors.descricao }"
                >
                  {{ form.errors.descricao }}
                </div>

                <div v-if="editMode" class="col-md-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label"
                      >Ativo</label
                    >
                    <select
                      id="ativo"
                      class="form-control"
                      v-model="form.ativo"
                    >
                      <option value="1">Sim</option>
                      <option value="0">Não</option>
                    </select>
                  </div>
                  <div
                    class="invalid-feedback mb-3"
                    :class="{ 'd-block': form.errors.valor }"
                  >
                    {{ form.errors.valor }}
                  </div>
                </div>

                <!-- teste corte de imagem -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <a
                        class="btn"
                        v-bind:class="{ disabled: checkbtn }"
                        @click="toggleShow2"
                        >Carregar Imagem</a
                      >

                      <my-upload
                        field="img"
                        @crop-success="cropSuccess"
                        @crop-upload-success="cropUploadSuccess"
                        @crop-upload-fail="cropUploadFail"
                        v-model="show"
                        :width="1280"
                        :height="720"
                        :url="urlBase"
                        :params="params"
                        :headers="headers"
                        :maxSize="5024"
                        :noCircle="true"
                        img-format="png"
                        langType="pt-br"
                      >
                      </my-upload>

                      <br />

                      <div
                        v-if="checkbtn"
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': checkbtn }"
                      >
                        Você chegou no limite de fotos enviadas
                      </div>

                      <div
                        class="invalid-feedback mb-3"
                        :class="{ 'd-block': form.errors.img }"
                      >
                        {{ form.errors.img }}
                      </div>

                      <ul class="image-list">
                        <li
                          class="list"
                          v-for="(item, index) in imgDataList"
                          :key="index"
                        >
                          <a
                            v-if="imgDataList"
                            class="btn btn-icon btn-2 btn-danger"
                            style="
                              padding: 1px 4px;
                              right: -20px;
                              top: -30px;
                              position: relative;
                            "
                            @click="removerImg(index, item)"
                          >
                            <i class="ni ni-fat-delete"></i>
                          </a>
                          <img
                            v-if="item"
                            :src="
                              '/storage/img/' +
                              setor +
                              '/' +
                              item
                            "
                            width="150"
                            height="100"
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!--- teste corte de imagem --->
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              Fechar
            </button>
            <button type="submit" class="btn btn-success">
              {{ buttonTxt }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import Pagination from "@/Components/Pagination";
import myUpload from "vue-image-crop-upload";
import moment from 'moment';

export default {
  props: ["noticias", "categorias", "prefeitura_url", "setor"],
  components: {
    "my-upload": myUpload,
    AdminLayout,
    Pagination,
    moment,
  },

  data() {
    return {
      modal: Object,

      show: false,
      urlBase:
        "/admin/galeria/uploadimg/" + this.setor,
      arquivo_nome: "",
      params: {
        setor: this.setor,
      },
      headers: {
        smail: "*_~",
      },
      imgDataUrl: "",
      imgDataList: [],

      filterAtivo: false,
      filter: "",
      editMode: false,
      form: this.$inertia.form({
        id: "",
        img: "",
        titulo: "",
        descricao: "",
        data_evento: "",
        noticia_categoria_id: "",
        ativo: "",
      }),
    };
  },
  computed: {
    formTitle() {
      return this.editMode === false ? "Adicionar Noticia" : "Editar Noticia";
    },
    buttonTxt() {
      return this.editMode === false ? "Salvar" : "Editar";
    },
    checkMode() {
      return this.editMode === false ? this.create : this.update;
    },

    checkbtn() {
      if (this.imgDataList.length >= 6) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm:ss");
    },

    //INICIO - Corte de Imagem
    toggleShow2() {
      this.show = !this.show;
    },

    removerImg(index, item) {
      this.imgDataList.splice(index, 1);
      console.log(this.imgDataList);
      axios.post("/admin/galeria/removerimg", { file: item });
    },

    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      this.imgDataUrl = imgDataUrl;
    },

    cropUploadSuccess(jsonData, field) {
      this.imgDataList.push(this.prefeitura_url+"/"+jsonData.file);
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("Arquivo: " + jsonData.file);
      console.log("Arquivo List: " + this.imgDataList);
      console.log("field: " + field);
      console.log("----------------- FORMULÁRIO -------------------");
      console.log(this.form);
    },

    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    //FIM - Corte de Imagem

    openModal() {
      this.imgDataList = [];
      this.editMode = false;
      this.form.clearErrors();
      this.modal.show();
      this.form.reset();
    },

    closeModal() {
      this.modal.hide();
      this.form.clearErrors();
      this.editMode = false;
    },

    create() {
      this.form.img = this.imgDataList;
      this.form.post(this.route("admin.noticias.store"), {
        preserveScroll: true,
        onSuccess: () => {
          this.closeModal();
          this.form.reset();
        },
      });
    },

    edit(noticia) {
      this.openModal();
      this.editMode = true;
      this.form = Object.assign(this.form, noticia);
      this.form.data_evento = moment(noticia.data_evento).format("YYYY-MM-DD");
      this.imgDataList = Object.values(noticia.img);
    },

    update() {
      this.form.img = this.imgDataList;
      this.form.patch(
        this.route("admin.noticias.update", this.form.id, this.form),
        {
          preserveScroll: true,
          onSuccess: () => {
            this.closeModal();
            this.form.reset();
          },
        }
      );
    },

    search() {
      this.$inertia.get(
        route("admin.noticias.index"),
        {
          filter: this.filter,
          ativo: this.filterAtivo,
        },
        { preserveState: true }
      );
    },

    filterNoticiasAtivos() {
      this.$inertia.get(
        route("admin.noticias.index"),
        {
          filter: this.filter,
          ativo: this.filterAtivo,
        },
        { preserveState: true }
      );
    },

    deleteModal(noticia) {
      Swal.fire({
        title: "Tem certeza que deseja deletar?",
        text: "Você não será capaz de reverter essa ação!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, deletar!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.form.delete(this.route("admin.noticias.destroy", noticia), {
            preserveScroll: true,
            onSuccess: () => {
              Swal.fire("Deletado!", "Noticia deletada", "success");
            },
          });
        }
      });
    },
  },

  mounted() {
    this.modal = new bootstrap.Modal(
      document.getElementById("modalNoticia"),
      {}
    );
  },
};
</script>

<style>
li.list {
  float: left;
  padding: 5px;
}
ul.image-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
</style>

